import type { ReactElement } from 'react';
import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { api } from '../api';

export function UserRegister(): ReactElement {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [displayName, setDisplayName] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  const submit = async (): Promise<void> => {
    setError(null);
    setSubmitting(true);
    try {
      await api.register(email, password, displayName || undefined);
      // Auto-login after registration to set the auth cookie.
      await api.login(email, password);
      navigate('/spaces', { replace: true });
    } catch (err) {
      setError(err instanceof Error ? err.message : 'registration failed');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h1 className="auth-brand">GimbalPortal</h1>
        <h2 className="text-lg font-semibold mb-4">Create Account</h2>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            void submit();
          }}
        >
          <label className="block text-xs text-slate-400 mb-1">Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full mb-3 bg-slate-900 border border-slate-700 rounded p-2"
            autoComplete="email"
          />
          <label className="block text-xs text-slate-400 mb-1">
            Display Name
          </label>
          <input
            type="text"
            value={displayName}
            onChange={(e) => setDisplayName(e.target.value)}
            className="w-full mb-3 bg-slate-900 border border-slate-700 rounded p-2"
          />
          <label className="block text-xs text-slate-400 mb-1">
            Password
          </label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full mb-3 bg-slate-900 border border-slate-700 rounded p-2"
            autoComplete="new-password"
          />
          {error && <p className="text-rose-400 text-sm mb-3">{error}</p>}
          <button
            type="submit"
            disabled={submitting}
            className="w-full bg-accent text-slate-900 rounded py-2 font-medium disabled:opacity-50"
          >
            Create account
          </button>
        </form>
        <p className="text-xs text-slate-400 mt-4 text-center">
          Already have an account?{' '}
          <Link to="/login" className="text-accent hover:underline">
            Sign in
          </Link>
        </p>
      </div>
    </div>
  );
}
